
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AccountActivation',
  setup() {
    return {

    };
  },
});
